import type { CompoundSelectSettingType } from '../../type';
import type { CampaignOptionType } from '../types';
import type { Campaign } from '~/types/graphql';

import { getVariantsInfo, isCampaignItemOperator } from '../utils';
import { useThemePageStore } from '~/stores/themePage';
import { useMemo } from 'react';

interface IUseSelectCampaignItemContent {
  configs?: CompoundSelectSettingType[];
  campaigns?: Campaign[];
}
export const useSelectCampaignItemContent = (props: IUseSelectCampaignItemContent) => {
  const { configs, campaigns } = props;

  const dataThemePages = useThemePageStore((state) => state.themePages);

  const campaignOptions: CampaignOptionType[] = useMemo(() => {
    return (
      campaigns?.map((campaign) => {
        return {
          label: campaign.name,
          value: campaign.id,
          variants: getVariantsInfo(campaign, dataThemePages),
        };
      }) || []
    );
  }, [campaigns, dataThemePages]);

  const formatConfigs = configs?.map((config) => {
    const isOperator = isCampaignItemOperator(config.id);
    return {
      ...config,
      campaignOptions: isOperator ? [] : campaignOptions,
      isOperator,
    };
  });
  return {
    formatConfigs,
  };
};
